export type OpKind = 'typed' | 'stamp' | 'assisted' | 'undo' | 'redo'

export interface LogOp {
  /** Milliseconds since the previous op, rounded to DT_STEP_MS and capped at MAX_DT_MS. */
  readonly dt: number
  /** Start offset of the replaced range in the document before this op. */
  readonly from: number
  /** End offset of the replaced range in the document before this op. */
  readonly to: number
  /** Inserted text. */
  readonly text: string
  readonly kind: OpKind
  /** Real gap in seconds, rounded to PAUSE_GRANULARITY_S, present only when the gap exceeded MAX_DT_MS. */
  readonly pause?: number
}

export interface KeystrokeLog {
  readonly version: 1
  /** Epoch seconds. */
  readonly createdAt: number
  readonly assisted: boolean
  readonly ops: readonly LogOp[]
}

export const LOG_VERSION = 1 as const
export const DT_STEP_MS = 50
export const MAX_DT_MS = 2000
export const PAUSE_GRANULARITY_S = 10

export const OP_KINDS: readonly OpKind[] = ['typed', 'stamp', 'assisted', 'undo', 'redo']
